<template>
    <div>
        <div class="ts-title d-lg-block d-none">
            {{ $t('timetable') }}
        </div>
        <div class="ts-schedules mt-4" v-if="timetable.schedules && timetable.schedules.length > 0">
            <div v-for="(item, i) in timetable.schedules" :class="['ts-schedule-item', {'ts-tz-msk': isMskTimezone }]" :key="i">
              <span class="ts-dow">{{ dayOfWeekShort(item.dateStart) }}</span>
              <span
                    class="ts-dow-schedule"
                    :title="timetable.name"
              >
                      <span class="ts-dow-time">{{ timeShort(item.dateStart) }}</span>
                      <span class="ts-dow-time ts-dow-time-msk" :title="$t('moscow_time_notice')"
                            v-if="timeShortMsk(item.dateStart)">{{ timeShortMsk(item.dateStart) }}</span>
                      <span class="ts-dow-name" :style="{ 'backgroundColor': color(item) }">{{ acronym(timetable.name) }}</span>
                  </span>
            </div>
        </div>
        <div v-else class="ts-schedules-none mt-5 mb-5">
            {{ $t('timetable_empty') }}.
        </div>
        <!--
        <div class="ts-more" v-if="timetable.schedules && timetable.schedules.length > 0">
            <span class="ts-more-link mb-3" @click="more">
                {{ $t('detailed_timetable') }} →
            </span>
        </div>
        -->
    </div>
</template>

<script>


import userApi from "../../../data/UserApi";
import moment from 'moment';

export default {
  name: 'TimetableSchedules',
  props: {
    timetable: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      isMskTimezone: true,
    }
  },

  computed: {
    pnItems() {
      let schedules = []
      for (let schedule of this.timetable.schedules) {
        if (schedule.pn && schedule.time_pn && this.isScheduleActual(0, schedule)) schedules.push(schedule)
      }
      schedules.sort((a, b) => a.time_pn.localeCompare(b.time_pn));
      return schedules
    },

    vtItems() {
      let schedules = []
      for (let schedule of this.timetable.schedules) {
        if (schedule.vt && schedule.time_vt && this.isScheduleActual(1, schedule)) schedules.push(schedule)
      }
      schedules.sort((a, b) => a.time_vt.localeCompare(b.time_vt));
      return schedules
    },

    srItems() {
      let schedules = []
      for (let schedule of this.timetable.schedules) {
        if (schedule.sr && schedule.time_sr && this.isScheduleActual(2, schedule)) schedules.push(schedule)
      }
      schedules.sort((a, b) => a.time_sr.localeCompare(b.time_sr));
      return schedules
    },

    chItems() {
      let schedules = []
      for (let schedule of this.timetable.schedules) {
        if (schedule.ch && schedule.time_ch && this.isScheduleActual(3, schedule)) schedules.push(schedule)
      }
      schedules.sort((a, b) => a.time_ch.localeCompare(b.time_ch));
      return schedules
    },

    ptItems() {
      let schedules = []
      for (let schedule of this.timetable.schedules) {
        if (schedule.pt && schedule.time_pt && this.isScheduleActual(4, schedule)) schedules.push(schedule)
      }
      schedules.sort((a, b) => a.time_pt.localeCompare(b.time_pt));
      return schedules
    },

    sbItems() {
      let schedules = []
      for (let schedule of this.timetable.schedules) {
        if (schedule.sb && schedule.time_sb && this.isScheduleActual(5, schedule)) schedules.push(schedule)
      }
      return schedules
    },

    vsItems() {
      let schedules = []
      for (let schedule of this.timetable.schedules) {
        if (schedule.vs && schedule.time_vs && this.isScheduleActual(6, schedule)) schedules.push(schedule)
      }
      schedules.sort((a, b) => a.time_vs.localeCompare(b.time_vs));
      return schedules
    },
  },

  mounted() {
    moment.locale(this.$i18n.locale)
    this.isMskTimezone = userApi.isMskTimezone()
  },

  methods: {
    isScheduleActual(dowNum, schedule) {
      if (schedule.start_date || schedule.end_date) {
        const date = moment().clone().weekday(dowNum).startOf('day')
        if (schedule.start_date && schedule.end_date)
          return date.isBetween(schedule.start_date, schedule.end_date, undefined, '[]')
        else if (schedule.start_date && !schedule.end_date)
          return date.isSameOrAfter(schedule.start_date)
        else if (!schedule.start_date && schedule.end_date)
          return date.isSameOrBefore(schedule.end_date)
      }
      return true
    },

    acronym(str) {
      let data = str.split(' ')
      let output = "";
      for (var i = 0; i < 2 && i < data.length; i++) {
        output += data[i].substring(0, 1);
      }
      if (output.length === 1) {
        output += data[0].substring(1, 2)
      }
      return output.toUpperCase()
    },

    dayOfWeekShort(str) {
      if (this.isMskTimezone) {
        return moment(str).format('ddd').toUpperCase();
      } else {
        return moment(str + ".000+0300").format('ddd').toUpperCase();
      }
    },

    timeShort(str) {
      if (this.isMskTimezone) {
        return moment(str).format("HH:mm");
      } else {
        return moment(str + ".000+0300").format("HH:mm");
      }
    },

    timeShortMsk(str) {
      if (this.isMskTimezone) return null
      return "(" + moment(str).format("HH:mm") + "\u00A0МСК)"
    },

    color(item) {
      if (item.color) return item.color
      return "hsla(" + item.id * 10 + ", 50%, 50%, 0.3)"
    },

    more() {
      this.$emit('more', this.timetable)
    }
  },

  components: {}
}
</script>

<style scoped>

.ts-schedules-none {
  margin-left: 20px;
}

.ts-more span {
  color: #5ab947;
  font-family: Manrope Bold;
  display: inline-block;
  border: 1px solid #5ab947;
  font-size: 16px;
  line-height: 48px;
  border-radius: 24px;
  padding-left: 30px;
  padding-right: 30px;
  text-align: center;
  margin-left: 20px;
  margin-top: 30px;
  opacity: 0.8;
  cursor: pointer;
}

.ts-more span:hover {
  opacity: 1;
}

.ts-schedule-item {
  padding-left: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.ts-schedule-item:nth-child(even) {
  background-color: #f0f5f7;
}

.ts-dow-schedule:last-child::after {
  display: none;
}

.ts-dow-schedule::after {
  content: " ";
  height: 15px;
  width: 1px;
  display: inline-block;
  border-right: 1px solid #bdbac3;
  vertical-align: middle;
  padding-left: 15px;
  margin-right: 10px;
}

.ts-title {
  font-size: 24px;
  line-height: 18px;
  color: #8b8496;
  font-family: "Manrope Bold";
  margin-bottom: 5px;
  padding-left: 20px;
}

.ts-dow {
  display: inline-block;
  width: 25px;
  color: #8b8496;
  font-family: "Manrope Bold";
  font-size: 14px;
  line-height: 18px;
}

.ts-tz-msk .ts-dow {
  width: 40px;
}

.ts-dow-time {
  display: inline-block;
  width: 45px;
  color: #231c37;
  font-family: "Manrope Bold";
  font-size: 14px;
  line-height: 18px;
}

.ts-dow-name {
  display: inline-block;
  width: 30px;
  text-align: center;
  font-size: 12px;
  color: #4f4d5c;
  line-height: 16px;
  background: #fed7e3;
  border-radius: 10px;
  cursor: help;
}

.ts-dow-time.ts-dow-time-msk {
  width: 73px;
  opacity: 0.5;
  font-size: 12px;
  cursor: help;
  margin-left: -6px;
}

.ts-dow-schedule {
  cursor: help;
}

.ts-dow-schedule:hover {
  opacity: 0.8;
}

</style>
